<template>
    <section class="l-section l-section--main o-start">
        <div class="l-container l-container--main l-container--horizontalPaddings">
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--7">
                    <div class="l-row">
                        <div class="l-row__column l-row__column--8">
                            <h1 class="a-title">Dziękujemy za złożenie zamówienia</h1>
                            <p class="a-text">
                              Będziemy w kontakcie!
                            </p>
                            <br /><br />
                            <a-button @click="$router.push({ name: 'dashboard-summary' })">
                                Powrót do początku
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    metaInfo: {
        title: 'Dziękujemy za złożone zamówienie'
    },
    created() {
        this.$store.dispatch('resetState')
    }
}
</script>
